/** Tooltip messages for recording status */
export enum RecordingTooltip {
  RECORDING_ENABLED = 'Your local laws may require you to notify your call recipients that calls are recorded. Please consult with independent legal counsel on the compliance requirements in your jurisdiction.',
  RECORDING_NOT_ENABLED = 'Recording cannot be enabled for this call',
  UNKNOWN = 'Fetching recording status',
}
